import React, { useEffect, useMemo, useState } from "react";
import AdminUserService from "../../../services/adminUserServices";
import { Column, useSortBy, useTable } from "react-table";
import ReactModal from "react-modal";
import ButtonWithIcon from "../../../components/StyledComp/ButtonWithIcon";
import {
  Button,
  Label,
  PageLink,
} from "../../../components/StyledComp/StyledComp";
import { useForm } from "react-hook-form";
import "../../../Styles/CommonStyles.scss";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useAppSelector } from "../../../store/hooks";


interface AddFormValue {
  MemberType: string | null;
  Description: string | null;
  Status: string | null;
}

const MemberType: React.FC = () => {
  const [memberType, setMemberType] = useState<any[] | undefined>([]);
  const [dialogTitle, setdialogTitle] = useState<string>('Add Member Type');
  const [Id, setId] = useState<number>(0);
  const [addTypeOpen, setaddTypeOpen] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any | undefined>();
  const [isEdit, setisEdit] = useState<boolean>(false);
  const form = useForm<AddFormValue>();
  const { register, control, handleSubmit, formState, setValue, reset } = form;
  const { errors, touchedFields, dirtyFields } = formState;
  const roleCapabilites = useAppSelector((state) => state.user.roleCapabilities);


  const getMemberType = async () => {
    const response = await AdminUserService.getMemberType();
    console.log(response);
    if (response.data.data != null) {
      setMemberType(response.data.data);
    } else {
      alert(response.data.errors[0]);
    }
  };
  useEffect(() => {
    getMemberType();
  }, []);

  const addMemberType = async (data: any) => {
    const response = await AdminUserService.addMemberType(data);
    console.log(response);
    if (response.data.data != null) {
      getMemberType();
      setaddTypeOpen(false);
      alert('Member Type Added Successfully');

    } else {
      alert(response.data.errors[0]);
    }
  };

  const updateMemberType = async (data: any) => {
    const response = await AdminUserService.updateMemberType(data);
    console.log(response);
    if (response.data.data != null) {
      getMemberType();
      setaddTypeOpen(false);
      alert('Member Type updated Successfully');

    } else {
      alert(response.data.errors[0]);
    }
  };

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "Id", Header: "ID", accessor: "Id" },
      { id: "MemberType", Header: "MemberType", accessor: "MemberType" },
      { id: "Description", Header: "Description", accessor: "Description" },
      {
        id: "Status",
        Header: "Status Id",
        accessor: "Status",

        Cell: ({ value }: { value: number }) => (
          <span>{value === 1 ? "Active" : "Inactive"}</span>
        ),
      },
      {
        id: "edit",
        Header: "Action",
        accessor: (row: any) => (
          <a
            className="d-flex editRow justify-content-center"
            onClick={() => handleEdit(row)}
          >
            <EditIcon></EditIcon>
            {/* Edit */}
          </a>
        ),
      },
    ],
    []
  );

  const handleEdit = (rowData: any) => {
    if (! roleCapabilites.some((obj: any) => Object.values(obj).includes('settings.edit'))) {
      alert("No Access");
      return;
    }
    setisEdit(true);
    setSelectedRow(rowData);
    reset();

    setValue('MemberType', rowData.MemberType);
    setValue('Description', rowData.Description);
    setValue('Status', rowData.Status);

    setId(rowData.Id);
    setdialogTitle('Update Member Type');
    setaddTypeOpen(true);
  };


  const data = useMemo(() => memberType, [memberType])!;

  const TableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    TableInstance;
  let index = 0;

  const onSubmit = (data: AddFormValue) => {
    const memberType = data.MemberType || '';
    const description = data.Description || '';
    const status = data.Status !== undefined ? data.Status : '';

    let id = {
      Id: Id,
    };
    const formData = {
      MemberType: memberType,
      Description: description,
      Status: status
    };
    console.log(formData)
    isEdit ? updateMemberType({ ...formData, ...id }) : addMemberType(formData);
  };

  const openDialog = () => {
    if (! roleCapabilites.some((obj: any) => Object.values(obj).includes('settings.create'))) {
      alert("No Access");
      return;
    }
    setisEdit(false)
    setValue('MemberType', '')
    setValue('Description', '')

    setdialogTitle('Add Member Type')
    setaddTypeOpen(true)
  }

  const handleClose = () => {
    reset()
    setaddTypeOpen(false)
  }
  return (
    <div className="container-fluid">
      <div className="dashboard-content-wrapper">
        <div className="d-flex justify-content-between" style={{ width: "90%" }}>
          <h1 className="page-heading">Member Type</h1>
          <div className="settings-add-button ms-4">
            <div className="secondary-button" onClick={() => openDialog()}>
              <AddCircleOutlineIcon></AddCircleOutlineIcon>
              <span className="ps-1">Add Member Type</span>
            </div>
            {/* <ButtonWithIcon
              icon={<></>}
              buttontext="Add Member Type"
              onClick={() => openDialog()}
            /> */}
          </div>
        </div>
        <div className="memberType-table">
          <table {...getTableProps}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps} key={index++}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.index}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}> {cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <ReactModal
        isOpen={addTypeOpen}
        className="addtype-modal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "1rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
          // style={{ marginBottom: "2rem", }}
          >
            {dialogTitle}
          </h1>
          <PageLink
            onClick={() => handleClose()}
            style={{ marginBottom: "1rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100">
              <Label>Member Type</Label>
              <input
                className="input-field-div"
                placeholder="Member Type"
                {...register("MemberType", { required: "Member Type is required" })}
                name="MemberType"
                id="MemberType"
                autoComplete="off"
              // value={state.data.MemberType}
              />
              <p className="form-error form-error-position">
                {errors.MemberType && errors.MemberType?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper w-100 mx-3">
              <Label>Description</Label>
              <input
                className="input-field-div"
                placeholder="Description"
                {...register("Description", { required: false })}
                name="Description"
                id="Description"
                autoComplete="off"
              // onChange={(e) => {
              //   updateInput(e);
              // }}
              // value={state.data.Description}
              />
              {/* <p className="form-error form-error-position">
                {errors.Description?.message}
              </p> */}
            </div>
            <select
              style={{ marginTop: "6px" }}
              className="dropdown-control-large"
              {...register("Status", { required: false })}
              name="Status"
              id="Status"
            // onChange={(e) => {
            //   updateInput(e);
            // }}
            // value={state.data.Status}
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            {/* <p className="form-error form-error-position">
              {errors.Status?.message}
            </p> */}
          </div>
          <div className="w-100 d-flex justify-content-center">
            <div className="submit-button-div">
              <Button type="submit">{isEdit ? 'Update' : 'Add'}</Button>
            </div>
          </div>
        </form>
      </ReactModal>
    </div>
  );
};

export default MemberType;
